export default window.newrelic;
